import Crud from '../views/NotificationInjurie/Crud'
import Entity from '../views/NotificationInjurie/Add'

let routes = {
    path: '/notification_injuries',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/notification_injuries/add',
            name: 'NewRazaoEntrada',
            component: Entity,
            meta: {
                pageTitle: 'Notificação de Agravo',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Adicionar Notificação de Agravo',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/notification_injuries/edit/:id?',
            name: 'EditRazaoEntrada',
            component: Entity,
            meta: {
                pageTitle: 'Notificação de Agravo',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Editar Notificação de Agravo',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/notification_injuries',
            name: 'list-notification-injuries',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Notificações de Agravos',
                access_nivel: ['6'],
                breadcrumb: [
                    {
                        text: 'Notificações de Agravos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
